import { useEffect } from 'react'

import { useUnit } from 'effector-react'

import ZoomIcon from '@/assets/icons/icon-zoom.svg'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import {
  $isOpen,
  loadZoomFromStorage,
  setZoom,
  setZoomControlsOpen,
  updateDesktopZoom,
} from '@/modules/chatting/ui/header/browser-zoom/models.ts'

import { IconButton } from '../../components/icon-button'
import { ZoomControls } from './ZoomControls'

export const BrowserZoom = () => {
  const isOpen = useUnit($isOpen)

  useEffect(() => {
    if (!window.zoomFactor) {
      setZoom(loadZoomFromStorage())
      updateDesktopZoom()
    }
  }, [])

  return (
    <Popover
      open={isOpen}
      onOpenChange={setZoomControlsOpen}
    >
      <PopoverTrigger asChild>
        <IconButton
          icon={ZoomIcon}
          iconClassName="h-7 w-7"
          tooltip="Zoom Settings"
        />
      </PopoverTrigger>
      <PopoverContent
        className="z-100 flex w-auto flex-col rounded-full px-4 py-1"
        align="end"
      >
        <ZoomControls />
      </PopoverContent>
    </Popover>
  )
}
